export default __webpack_public_path__ + "assets/favicon-180x180.png";